import { useState, useEffect } from "react"
import { useDispatch } from "react-redux"
import { FetchMethods } from "../../../../interface/Enums/methods.enum"
import { IDepartment, IEvaluationDynamicDocument } from "../../../../interface"
import { setError } from "../../../../store/reducers/errorReducer"
import { fetchAPI } from "../../../../utils/FetchApi"

const DepartmentSelection = ({selectedDepartment, evaldoc}:{selectedDepartment:Function, evaldoc:IEvaluationDynamicDocument}) => {
  const dispatch = useDispatch()
  //Get the list of my users
  const [listOfDeparments, setListOfDeparments] = useState<IDepartment[]>([])

useEffect(()=>{
    (async()=>{
      try {
        const getDeparments:IDepartment[] =  await fetchAPI("/evaluationcmds/get-my-departments", FetchMethods.GET);

        if(getDeparments.hasOwnProperty("error")) throw new Error("Departments could not be loaded")

        setListOfDeparments(getDeparments)

      } catch (error:any) {
          if (error)dispatch(setError(error.message))
      }
      
     
    })()
},[dispatch]);
  
  return (
    <select onChange={({target})=>{
      const pseudoIndex = parseInt(target.value)
      selectedDepartment(listOfDeparments[pseudoIndex])
    }} className="form-control">
      {evaldoc.selectedDepartment?<option className="form-control" value={-1}>{evaldoc.selectedDepartment.name}</option>:<option className="form-control" value="---">---</option>}
      
      {
       listOfDeparments.map((u:IDepartment,i)=>(
          <option className="form-control" key={i} value={i}>{u.name}</option>
        ))
      }
    </select>
  )
}

export default DepartmentSelection